$(() => {
  const searchBox = $("#search-box");
  $(".search-btn").on("click", (e) => {
    e.preventDefault();
    searchBox.addClass("open-search");
    setTimeout(() => {
      $("#search-box input[name='s']").focus();
    }, 100);
  });
  // close search if click out side or close
  searchBox.on("click", (e) => {
    let originalTarget = e.originalEvent.target;
    if (originalTarget.classList.contains("open-search") || originalTarget.classList.contains("close")) {
      searchBox.removeClass("open-search");
    }
  });
});
